import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import type { SubMenuItem } from "@/lib/config/navigationConfig";
import { NavIcon } from "./NavIcon";

interface ErpSidebarSubItemProps {
  subItem: SubMenuItem;
  isActive: boolean;
}

export function ErpSidebarSubItem({
  subItem,
  isActive,
}: ErpSidebarSubItemProps) {
  return (
    <Link
      to={subItem.href}
      className={cn(
        "flex items-center gap-2.5 h-[36px] px-2.5 mx-2 rounded-sm w-auto",
        "text-[14px] transition-colors duration-100",
        isActive
          ? "bg-gray-100 dark:bg-gray-800 font-medium text-[#0F0F10] dark:text-gray-100"
          : "text-[#0F0F10]/60 dark:text-gray-400 hover:bg-gray-100/50 dark:hover:bg-gray-800/50 hover:text-[#0F0F10] dark:hover:text-gray-100"
      )}
    >
      <NavIcon
        icon={subItem.icon}
        className={cn(
          "w-[15px] h-[15px] shrink-0",
          isActive
            ? "text-[#0F0F10] dark:text-gray-100"
            : "text-[#0F0F10]/55 dark:text-gray-500"
        )}
      />
      <span className="truncate">{subItem.name}</span>
      {subItem.Badge && <subItem.Badge />}
    </Link>
  );
}
